var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Top_Up",
    "data-name": "Top Up",
    transform: "translate(-1.618 -1.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M12.173,25.161a6.2,6.2,0,0,0,0-8.752,6.066,6.066,0,0,0-2.888-1.619A6.141,6.141,0,0,0,3.422,16.41a6.041,6.041,0,0,0-1.783,3.971A5.559,5.559,0,0,0,1.8,22.273a6.066,6.066,0,0,0,1.619,2.888A6.187,6.187,0,0,0,12.173,25.161Zm-2.057-5.513a1.167,1.167,0,0,1,1.16,1.159,1.186,1.186,0,0,1-1.171,1.171l-1.149-.011.011,1.1a1.171,1.171,0,0,1-2.341,0l.011-1.1-1.149.011a1.186,1.186,0,0,1-1.171-1.171,1.2,1.2,0,0,1,1.16-1.159h1.16v-1.2a1.158,1.158,0,0,1,1.16-1.16,1.167,1.167,0,0,1,1.16,1.16v1.2Z",
    transform: "translate(0 7.022)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M22.18,4.936v5.879H19.86V4.936a.616.616,0,0,0-.851-.572L6.741,8.99a2.078,2.078,0,0,0-1.346,1.965v1.037a5.779,5.779,0,0,0-2.321,4.641V10.955A4.406,4.406,0,0,1,5.921,6.824L18.2,2.183A3.056,3.056,0,0,1,19.241,2,2.947,2.947,0,0,1,22.18,4.936Z",
    transform: "translate(0.858 0)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M23.293,14.4V15.95a.772.772,0,0,1-.758.773H20.276a1.6,1.6,0,0,1-1.624-1.408,1.545,1.545,0,0,1,.449-1.238,1.471,1.471,0,0,1,1.083-.449H22.52a.776.776,0,0,1,.774.774Z",
    transform: "translate(10.325 6.599)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M29.6,15.589H31.2a1.559,1.559,0,0,0,1.562-1.547v-.681a5.859,5.859,0,0,0-5.874-5.817H8.948A5.828,5.828,0,0,0,5.418,8.72a5.761,5.761,0,0,0-2.343,4.641v2.754a.88.88,0,0,0,1.187.774,8.574,8.574,0,0,1,11.311,8.06,8.9,8.9,0,0,1-.765,3.419.861.861,0,0,0,.75,1.222H26.883a5.859,5.859,0,0,0,5.874-5.817v-.294A1.559,1.559,0,0,0,31.2,21.932H29.836a3.389,3.389,0,0,1-3.328-2.352,3.1,3.1,0,0,1,.844-3.063,3.13,3.13,0,0,1,2.25-.928Zm-8.561-.309H13.229a1.16,1.16,0,1,1,0-2.321h7.811a1.16,1.16,0,1,1,0,2.321Z",
    transform: "translate(0.858 2.863)",
    fill: "#71207c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopup);
export default __webpack_public_path__ + "static/media/icon_topup.8898336ed732356232bea76129518c14.svg";
export { ForwardRef as ReactComponent };